


angular.module('forms', [
	'ui.select',
	'monospaced.elastic',  // textarea autoresize
	'angularFileUpload',
	'ngFileUpload',  // (backreference) TODO choose one :)

	'forms.fields.binary',
	'forms.fields.currency',
	'forms.fields.date',
	'forms.fields.dictionary',
	'forms.fields.filterreference',
	'forms.fields.gridreference',
	'forms.fields.backreference',
	'forms.fields.interval',
	'forms.fields.password',
	'forms.fields.password_single',
	'forms.fields.reference',
	'forms.fields.composite',
	'forms.fields.text',
	'forms.fields.tags',
	'forms.fields.formbuilder',
	//'forms.fields.datelist',   // requires 'gm.datepickerMultiSelect'
	//'forms.fields.position',   // requires 'uiGmapgoogle-maps'
	//'forms.fields.daterange',  // requires 'daterangepicker'
	//'forms.fields.html.medium',// requiers 'angular-medium-editor'
])

.value('FormsTplDir', 'framework/partials/forms/')
.value('FormsFormGridTplUrl', null)  // evaluates to FormsTplDir + 'form-grid.html'
.value('FormsFormPaneTplUrl', null)  // evaluates to FormsTplDir + 'form-pane.html'
.value('FormsFieldBoxTplUrl', null)  // evaluates to FormsTplDir + 'field-box.html'

